module.exports = __webpack_public_path__ + "img/exit-icon-left.41501fc9.png";